import { render } from "./Edit.vue?vue&type=template&id=901d5544"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "901d5544"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('901d5544', script)) {
    api.reload('901d5544', script)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=901d5544", () => {
    api.rerender('901d5544', render)
  })

}

script.__file = "resources/js/Pages/Media/Edit.vue"

export default script